import React from "react";
import StatusGuestsList from "../StatusGuestsListComponent/StatusGuestsListComponent";
import "./PendingGuests.scss";

const PendingGuests = () => {
  return (
    <div className="pendingGuestsPage">
      <StatusGuestsList
        statusFilter="Pending"
        showMobileWhatsApp={true}
      />
    </div>
  );
};

export default PendingGuests;